var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightningFill = function SvgLightningFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.75 5.98c0-2.8 0-4.2-.53-4.77a1.99 1.99 0 0 0-1.79-.63c-.77.12-1.65 1.21-3.388 3.39l-4.46 5.56c-1.34 1.66-2 2.49-2 3.19-.01.6.27 1.18.75 1.56.54.43 1.61.43 3.74.43h.55c.56 0 .84 0 1.05.1.18.09.34.24.43.43.1.21.1.49.1 1.05v1.66c0 2.79 0 4.19.52 4.76.45.49 1.12.73 1.78.62.76-.13 1.64-1.22 3.38-3.4l4.45-5.57c1.33-1.67 1.99-2.5 1.99-3.2 0-.61-.28-1.19-.76-1.57-.55-.44-1.62-.44-3.75-.44h-.56c-.57 0-.85 0-1.06-.11a1 1 0 0 1-.44-.44c-.11-.22-.11-.5-.11-1.06V5.87Z"
  })));
};
export default SvgLightningFill;